<cm-dynamic-list
  [data]="persons"
  [addLabel]="addLabel"
  [columns]="columns"
  [filters]="filters"
  [filterPredicate]="filterPredicate"
  [selectionActions]="personsSelectionActions"
  [rowClassGetter]="rowClassGetter"
  [actions]="actions"
  [isLoading]="isLoading"
  (itemClick)="itemClick.emit($event)"
  [emptyPlaceholder]="emptyPlaceholder"
  (add)="add.emit()"
  (filterChange)="filterChange.emit($event)"
></cm-dynamic-list>
